<template>
  <div class="header">
<!--    <div class="image-box">-->
<!--      <img class="logo-img" src="@/assets/images/logo.png" />-->
<!--    </div>-->
<!--    <div class="awesome" v-if="token">-->
<!--      <div class="yonghu" v-if="token">-->
<!--        <el-dropdown @command="handleCommand">-->
<!--          <div class="yonghu-box">-->
<!--            <img src="@/assets/images/yonghu.png" />-->
<!--            <span class="el-dropdown-link">{{ token.email }}</span>-->
<!--          </div>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item command="a">個人資料</el-dropdown-item>-->
<!--            <el-dropdown-item command="b">登出</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { logout } from "@/api/security";
import { removeToken, removeAll } from "@/utils/auth";
export default {
  computed: {
    token() {
      return this.$store.getters.adminUserInfo;
    },
  },
  methods: {
    handleCommand(v) {
      if (v == "a") {
        this.$router.push({ path: "/personalInformation" });
      }
      if (v == "b") {
        this.onLogoutClick();
      }
    },
    onUserName() {
      this.$router.push({ path: "/personalInformation" });
    },
    onLogoutClick() {
      this.logout();
    },
    logout() {
      let d = {
        refreshToken: this.$store.getters.adminUserInfo.refreshToken,
      };
      logout(d).then(() => {
        removeToken();
        removeAll();
        this.$store.dispatch("setAdminUserInfo", null);
        location.reload();
      });
    },
  },
};
</script>

<style lang="scss"  scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 0px;
  padding-left: 64px;
  padding-right: 64px;
  background-color: #fff;
  color: #fff;
  box-shadow: 1px 6px 8px rgba(0, 0, 0, 0.16);
}
.logo {
  display: flex;
  align-items: center;
}
.logo-img {
  display: block;
  height: 72px;
}
.logo-text {
  font-size: 20px;
  font-weight: bold;
}
.userinfo {
  display: flex;
  font-size: 20px;
  align-items: center;
}
.userinfo-button,
.userinfo-divider,
.userinfo-text {
  margin: 0 20px;
}
.userinfo-button {
  border: 3px solid #fff;
}
.userinfo-cursor {
  cursor: pointer;
  padding-right: 20px;
}

.awesome {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.awesome-user {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 20px;
  cursor: pointer;
  .awesome-user-text {
    margin-left: 10px;
    font-size: 18px;
    font-weight: bolder;
  }
}

.userinfo {
  display: flex;
  font-size: 20px;
  align-items: center;
  background-color: #619500;
  height: 100%;
  padding: 0 20px;
  cursor: pointer;
}
.yonghu {
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  border-bottom: 1px solid;
  font-size: 20px;
  margin-left: 10px;
  cursor: pointer;
}
.yonghu-box{
  display: flex;
  align-items: center;
}
</style>
